import {
  FcScrollTargetClasses,
  FinanceCalculatorTheme,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const scrollToTargetButtonStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcScrollTargetClasses
>(
  ({ palette, typography }) => ({
    container: {
      marginLeft: 5,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 15,
      height: 15,
      borderRadius: '100%',
      background: palette.primary.main,
      position: 'relative',
      cursor: 'pointer',
    },
    labelText: {
      color: palette.common.white,
      fontWeight: typography.fontWeightBold,
      textAlign: 'center',
    },
  }),
  { name: 'FC_ScrollToTargetButton' }
)

export default scrollToTargetButtonStyles
